// Note: added this to resolve react-joyride lib issue : https://github.com/gilbarbara/react-joyride/issues/772
(window as any).global = window;
